import React from "react";
import "./ControlsDropdown.css";

const ControlsDropdown = ({
  disabled = false,
  label,
  options = [],
  onChange
}) => {
  return (
    <>
      <label className="control-label">
        {label}
      </label>
      <select className="control-item dropdown" onChange={onChange} disabled={disabled}>
        {options.map((opt, i) => (
          <option key={i} value={opt.value ?? opt}>
            {opt.label ?? opt}
          </option>
        ))}
      </select>
    </>
  );
}

export { ControlsDropdown }
